import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { AppUpdate } from '@capawesome/capacitor-app-update'
import { configClient } from '@egw/config'
import { type Config } from '../../config'

export const getCurrentAppVersion = async (): Promise<string> => {
  // Get current app version for Android, or get app info for iOS, and return the version
  return (await App.getInfo()).version
}

export const openAppStore = async (): Promise<void> => {
  const config = configClient.getConfig() as Config
  const platform = Capacitor.getPlatform()
  // Open App Store for iOS, or Google Play for Android
  await AppUpdate.openAppStore({ appId: platform === 'ios' ? config.iosAppleId : '' })
}
